import React, {useEffect,useState} from 'react'
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { fetchData,exerciseOptions, youtubeoptions } from '../utils/FetchData';
import Detail from '../components/Detail';
import ExerciseVideos from '../components/ExerciseVideos';
import SimilarExercises from '../components/SimilarExercises';

const ExerciseDetail = () => {
  const [exerciseDetail,setExerciseDetail] = useState({});
  const [exerciseVideos,setExerciseVideos] = useState([]);
  const [ targetMuscleExercises,setTargetMuscleExercises]  = useState([]);
  const [equipmentExercisesData,setEquipmentExercisesData] = useState([]);
  const {id} = useParams();

  useEffect(() => {
      const fetchExercisesData = async () => {
        const exerciseDbUrl = 'https://exercisedb.p.rapidapi.com';
        const youtubeSearchUrl = 'https://youtube-search-and-download.p.rapidapi.com';

        const exerciseDetailData = await fetchData(`${exerciseDbUrl}/exercises/exercise/${id}`,exerciseOptions);
        setExerciseDetail(exerciseDetailData);

        const exercisesVideosData = await fetchData(`${youtubeSearchUrl}/search?query=${exerciseDetailData.name}`,youtubeoptions);
        setExerciseVideos(exercisesVideosData.contents);

        const targetMuscleExercisesData = await fetchData(`${exerciseDbUrl}/exercises/target/${exerciseDetailData.target}`,exerciseOptions);
        setTargetMuscleExercises(targetMuscleExercisesData);

        const equipmentExercisesData = await fetchData(`${exerciseDbUrl}/exercises/equipment/${exerciseDetailData.equipment}`,exerciseOptions);
        setEquipmentExercisesData(equipmentExercisesData);
      }
      fetchExercisesData();
  },[id]);

  return (
    <Box>
      <Detail exerciseDetail={exerciseDetail}/>
      <ExerciseVideos exerciseVideos={exerciseVideos} />
      <SimilarExercises targetMuscleExercises={targetMuscleExercises} equipmentExercisesData={equipmentExercisesData}/>
    </Box>
  )
}

export default ExerciseDetail